export default __webpack_public_path__ + "static/media/DRIVERLICENSEDOCTORCERTIFICATE_BLANK.c5cb97bd.png";